<ng-template #menuItemContent>
  <i [ngClass]="item.icon" class="layout-menuitem-icon"></i>
  <span
    class="layout-menuitem-text overflow-hidden text-ellipsis whitespace-nowrap"
    >{{ item.label }}</span
  >
  @if (item.disabled && item.disabledBadge && item.disabledBadge.show !== false)
  {
  <span
    class="ml-auto text-xs px-2 py-1 rounded whitespace-nowrap"
    [style.background]="'var(--surface-hover)'"
    [style.color]="'var(--text-color-secondary)'"
    [style.flex-shrink]="'0'"
    >{{ item.disabledBadge.label || 'Coming Soon' }}</span
  >
  } @if (item.items) {
  <i class="pi pi-fw pi-angle-down layout-submenu-toggler"></i>
  }
</ng-template>

<ng-container>
  @if (root && item.visible !== false) {
  <div class="layout-menuitem-root-text">{{ item.label }}</div>
  } @if ((!item.routerLink || item.items) && item.visible !== false &&
  !item.disabled) {
  <a
    [attr.href]="item.url"
    (click)="itemClick($event)"
    (mouseenter)="onMouseEnter()"
    [ngClass]="item.class"
    [attr.target]="item.target"
    [attr.tabindex]="0"
    pRipple
    [pTooltip]="item.label"
    [tooltipDisabled]="!(isSlim() && root && !active)"
  >
    <ng-container *ngTemplateOutlet="menuItemContent"></ng-container>
  </a>
  } @if ((!item.routerLink || item.items) && item.visible !== false &&
  item.disabled) {
  <span
    [pTooltip]="item.label + (item.disabledBadge && item.disabledBadge.show !== false ? '<br>(' + (item.disabledBadge.label || 'Coming Soon') + ')' : '')"
    [tooltipOptions]="{ escape: false }"
    tooltipPosition="right"
    [style.display]="'block'"
  >
    <a
      [ngClass]="item.class"
      class="opacity-50"
      [style.cursor]="'default'"
      [style.pointer-events]="'none'"
      [attr.tabindex]="-1"
      [attr.aria-disabled]="true"
    >
      <ng-container *ngTemplateOutlet="menuItemContent"></ng-container>
    </a>
  </span>
  } @if (item.routerLink && !item.items && item.visible !== false &&
  !item.disabled) {
  <a
    (click)="itemClick($event)"
    (mouseenter)="onMouseEnter()"
    [ngClass]="item.class"
    [routerLink]="item.routerLink"
    routerLinkActive="active-route"
    [routerLinkActiveOptions]="
      item.routerLinkActiveOptions || {
        paths: 'exact',
        queryParams: 'ignored',
        matrixParams: 'ignored',
        fragment: 'ignored'
      }
    "
    [fragment]="item.fragment"
    [queryParamsHandling]="item.queryParamsHandling"
    [preserveFragment]="item.preserveFragment"
    [skipLocationChange]="item.skipLocationChange"
    [replaceUrl]="item.replaceUrl"
    [state]="item.state"
    [queryParams]="item.queryParams"
    [attr.target]="item.target"
    [attr.tabindex]="0"
    pRipple
    [pTooltip]="item.label"
    [tooltipDisabled]="!(isSlim() && root)"
  >
    <ng-container *ngTemplateOutlet="menuItemContent"></ng-container>
  </a>
  } @if (item.routerLink && !item.items && item.visible !== false &&
  item.disabled) {
  <span
    [pTooltip]="item.label + (item.disabledBadge && item.disabledBadge.show !== false ? '<br>(' + (item.disabledBadge.label || 'Coming Soon') + ')' : '')"
    [tooltipOptions]="{ escape: false }"
    tooltipPosition="right"
    [style.display]="'block'"
  >
    <a
      [ngClass]="item.class"
      class="opacity-50"
      [style.cursor]="'default'"
      [style.pointer-events]="'none'"
      [attr.tabindex]="-1"
      [attr.aria-disabled]="true"
    >
      <ng-container *ngTemplateOutlet="menuItemContent"></ng-container>
    </a>
  </span>
  } @if (item.items && item.visible !== false) {
  <ul
    #submenu
    [@children]="submenuAnimation"
    (@children.done)="onSubmenuAnimated($event)"
  >
    @for (child of item.items; track child; let i = $index) {
    <li
      app-menuitem
      [item]="child"
      [index]="i"
      [parentKey]="key"
      [class]="child['badgeClass']"
    ></li>
    }
  </ul>
  }
</ng-container>
